export const getRootWindow = () => {
  let rootWindow;
  if (window.opener) {
    rootWindow = window.opener;
  } else if (window.self !== window.top) {
    rootWindow = window.parent;
  }
  return rootWindow;
};

export const waitForWindowClose = (popupWindow: Window): Promise<boolean> => {
  return new Promise((resolve) => {
    const checkInterval = setInterval(() => {
      try {
        if (popupWindow.closed) {
          clearInterval(checkInterval);
          resolve(true);
        }
      } catch (e) {
        clearInterval(checkInterval);
        resolve(false);
      }
    }, 500);
  });
};
